import React, { ReactNode } from 'react';
import { Icons } from '../../Icons/Icons';
import { Card } from '../../Layout/Card';
import { InputTextarea } from 'primereact/inputtextarea';
import { GLStep } from '../../../../../ViewModel/TutorialStateViewModel';
import { TutorialFlyout } from '../../TutorialFlyout';

interface TextEntryListProps {
    title: string;
    text: string;
    headerIcon?: ReactNode;
    onChanged: React.ChangeEventHandler<HTMLTextAreaElement>;
    className?: string;
    tutorialSteps?: GLStep[];
}


export const TextAreaSection: React.FC<TextEntryListProps> = ({ title, text, headerIcon, onChanged, className, tutorialSteps }) => {


    const header = headerIcon ? headerIcon : <Icons.CardBulletIcon />;



    return (
        <div className={'gl-list ' + (className ?? '')} >
            <Card noMargin disableClick>
                <TutorialFlyout steps={tutorialSteps}>
                    <div className='flex flex-row justify-content-start align-items-center mb-3'>
                        {header}
                        <p className='gl-list-header-spacing gl-content-header-typography'>{title}</p>
                    </div>
                </TutorialFlyout>


                <InputTextarea value={text} autoResize onChange={(e) => onChanged(e)} />


            </Card>
        </div>
    );
};